import { PropsWithChildren, useEffect, useState } from 'react';
import { TestAttemptContext } from './test-attempt-context';
import { AttemptQuestion } from '../../../utils/types.ts';

export const TestAttemptProvider = ({ children }: PropsWithChildren) => {
  const [attemptId, setAttemptId] = useState<number>();
  const [attemptQuestions, setAttemptQuestions] = useState<AttemptQuestion[]>(
    [],
  );

  useEffect(() => {
    setAttemptQuestions([]);
  }, [attemptId]);

  return (
    <TestAttemptContext.Provider
      value={{
        attemptId,
        setAttemptId,
        attemptQuestions,
        setAttemptQuestions,
      }}
    >
      {children}
    </TestAttemptContext.Provider>
  );
};
